import { BASE_URL } from "../../constants/urls";
import { Request } from "../Request";

export const saveDeal = async (data: any) => {
  return Request.post("/deal", { data: data });
};

export const getDeal = async (id: any) => {
  return Request.get(`/deal/${id}`, {});
};

export const getAll = async () => {
  return Request.get(`/deal`, {});
};

export const getCount = async () => {
  return Request.get(`/deals/get-count`, {});
};

export const deleteDeal = async (id: any) => {
  return Request.del(`/deal/${id}`, {});
};

export const updateDeal = async (id: any, data: any) => {
  return Request.put(`/deal/${id}`, { data: data });
};

export const getActive = async () => {
  return Request.get(`/deals/get-active`, { noAuth: true });
};

export async function uploadImage(image: File) {
  const formData = new FormData();
  formData.append("image", image);
  try {
    const response = await fetch(`${BASE_URL}/media`, {
      method: "POST",
      body: formData,
    });

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      alert("Something went wrong! Try Again.");
    }
  } catch (error) {
    alert("Something went wrong! Try Again.");
  }
}
